(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-home"] && !Shopify.designMode) return;
  try {
    
if (!window.huanengRfqDialogInitialized) {
  window.huanengRfqDialogInitialized = true;
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-hn-rfq-open]');
    var closer = event.target.closest('[data-hn-rfq-close]');
    var dialog = document.getElementById('HuanengRfqDialog');
    if (opener && dialog) {
      event.preventDefault();
      if (typeof dialog.showModal === 'function') dialog.showModal();
    }
    if (closer && dialog) dialog.close();
    if (event.target === dialog) dialog.close();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
